import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      action: uploadFile,
      loading: false,
      form: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    handleChange({
      file
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (file.status === 'done') {
        this.form.imgUrl = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        this.loading = false;
        this.$emit('itemChange', this.form);
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的图片格式,例如') + ':jpg,png,jpeg');
      }
      const isLt5k = file.size / 1024 < 500;
      if (!isLt5k) {
        this.$message.error(this.$t('上传图片应小于') + '500kb');
      }
      return isJpgOrPng && isLt5k;
    }
  }
};